import React, { useCallback, useEffect, useRef, useState } from "react";
import { LuFolderTree } from "react-icons/lu";
import { PiDotsThreeOutlineVerticalBold } from 'react-icons/pi';
import { IoMdRefresh } from "react-icons/io";
import { getAxios } from "../../axios/Axios";
import request, { EEZYERP_REDIRECT } from "../../request/request";
import { Button } from "react-bootstrap";
import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Paginator } from "primereact/paginator";
import { Dialog } from "primereact/dialog";
import { useNavigate } from "react-router-dom";
import Loader from "../loader/Loader";
import { Dropdown } from "primereact/dropdown";
import WebsiteListFilterDrawer from "./WebsiteListFilterDrawer";
import { TieredMenu } from "primereact/tieredmenu";
import { useGlobal } from "../../context/GlobalContext";

const WebsiteList = () => {
  const { setDashboardTitle } = useGlobal();
  const [websiteListData, setWebsiteListData] = useState();
  const [totalRecords, setTotalRecords] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(50);
  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [selectedMappingStatus, setSelectedMappingStatus] = useState("ANY");
  const [selectWebsiteType, setSelectWebsiteType] = useState("");
  const [searchWebsiteId, setSearchWebsiteId] = useState("");
  const navigate = useNavigate();
  const [filterDrawerVisible, setFilterDrawerVisible] = useState(false);
  const mappingType = [
    { name: "ANY", code: "ANY" },
    { name: "Not Started", code: "NOT_STARTED" },
    { name: "WIP", code: "WIP" },
    { name: "Completed", code: "COMPLETED" },
  ];

  const websiteTypeItems = [
    { name: "Customized Website", code: "Customized Website" },
    { name: "Template Based Website ", code: "Template Based Website" },
  ];
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const params = {
        page: currentPage,
        rows,
      };

      if (searchText?.trim()) {
        params.website_name = searchText.trim();
      }

      if (selectedMappingStatus?.code && selectedMappingStatus.code !== "ANY") {
        params.mapping_status = selectedMappingStatus.code;
      }

      if (selectWebsiteType?.code) {
        params.website_type = selectWebsiteType.code;
      }

      if (searchWebsiteId?.trim()) {
        params.website_id = searchWebsiteId.trim();
      }

      const response = await getAxios(request.getwebsiteList, {
        params,
      });

      if (response?.data.apiresponse?.type === "OK") {
        setWebsiteListData(response?.data?.records);
        setTotalRecords(response?.data?.metadata?.TotalRecordCount);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  }, [currentPage, rows, searchText, selectedMappingStatus, selectWebsiteType, searchWebsiteId]);

  useEffect(() => {
    fetchData();
  }, [first, rows, currentPage]);

  const onPageChange = (event) => {
    setFirst(event.first);
    setCurrentPage(event.page + 1);
    setRows(event.rows);
  };

  const hanldeWebisteSearch = useCallback(async () => {
    setFilterDrawerVisible(false);
    await fetchData();
  }, [fetchData]);

  const handleResetFilter = useCallback(async () => {
    setSearchText("");
    setSelectedMappingStatus("ANY");
    setSelectWebsiteType("");
    setSearchWebsiteId("");
    setFirst(0);
    setCurrentPage(1);
    setFilterDrawerVisible(false);
    await fetchData();
  }, [fetchData]);

  const handleNavigation = useCallback((data, route) => {
    navigate(`${route}?id=${data?.website_id}`, { state: data });
  }, []);

  const renderWebsiteDetails = (rowData) => {
    return (
      <div className="webiste-detail-container">
        <div>{rowData?.website_name}</div>
        <div className="website-details-id">
          <span>Website id : </span>
          <a
            href={`${EEZYERP_REDIRECT}webSiteId=${rowData?.website_id}`}
            target="_blank" rel="noreferrer"
          >
            {rowData?.website_id}
          </a>
        </div>
      </div>
    );
  };

  const renderActions = (rowData) => {
		const menu = useRef(null);
		const navigate = useNavigate();
		const items = [
			{
				label: 'Map Categories',
				icon: 'pi pi-sitemap',
				command: () => {handleNavigation(rowData, '/mapped-screen')},
			},

			{
				label: 'Manage SEO tags',
				icon: 'pi pi-cog',
				command: () => {handleNavigation(rowData, '/manage-seo')},
			},
		];
		return (
			<div className=" cursor-pointer flex justify-content-center">
				<TieredMenu model={items} popup ref={menu} breakpoint="767px" />
				<span
					className="global-category-action"
					icon="pi pi-check"
					aria-label="Filter"
					label="Show"
					onClick={(e) => menu.current.toggle(e)}
				>
					<PiDotsThreeOutlineVerticalBold />
				</span>
			</div>
		);
	};

  const renderProgressbar = (rowData) => {
    let progressBar =
      rowData?.total_category_count / rowData?.total_mapped_category_count;

    if (isNaN(progressBar) || !isFinite(progressBar)) {
      progressBar = 0;
    }
    return (
      <div className="d-flex w-100 gap-1 align-items-center">
        <div className="progress  w-100">
          <div
            className={`progress-bar bg-success `}
            role="progressbar"
            style={{ width: `${progressBar}%` }}
            aria-valuemin="0"
            aria-valuemax="100"
          >
            {progressBar}%
          </div>
        </div>
        <span className="mapping-count">
          {" "}
          {rowData?.total_mapped_category_count}/{rowData?.total_category_count}{" "}
        </span>
      </div>
    );
  };

  const renderWebsiteHost = (rowData) => {
    const websiteHost = rowData?.website_host || "";
    const url =
      websiteHost.startsWith("http://") || websiteHost.startsWith("https://")
        ? websiteHost
        : `http://${websiteHost}`;

    return (
      <a href={url} target="_blank" rel="noopener noreferrer">
        {websiteHost}
      </a>
    );
  };

  useEffect(()=> {
    setDashboardTitle('My Website List');
  }, [])
  return (
    <div>
      {loading && <Loader />}
      <div className="m-2 d-flex gap-2 justify-content-between align-items-center  w-100 ">
        <div className="pr-3">
          <span className="font-bold ">Total Records:</span>
          <span> {totalRecords} </span>
        </div>
        <div
          className="d-flex  flex-row gap-2 align-items-center prime-react-btn"
        >
          <Button
            variant="outline-secondary"
            disabled={loading}
            onClick={() => setFilterDrawerVisible(true)}
            title="filter"
          >
            <i className="pi pi-filter" />
          </Button>
          <button
            className="btn submit-btn text-white"
            disabled={loading}
            onClick={!loading ? fetchData : null}
            title="refresh"
          >
            <IoMdRefresh size="1.3em" />
          </button>
        </div>
      </div>

      <DataTable value={websiteListData} showGridlines>
        <Column body={renderWebsiteDetails} header="Website Name" />
        <Column body={renderWebsiteHost} header="URL" />
        <Column field="webapp_path" header="Website Path" />
        <Column field="section" header="Section" />
        <Column body={renderProgressbar} header="Mapped %" />
        <Column body={renderActions} header="Details" />
      </DataTable>

      <Paginator
        first={first}
        rows={rows}
        totalRecords={totalRecords}
        rowsPerPageOptions={[50, 100, 150, 200, 250]}
        onPageChange={onPageChange}
      />

      <Dialog visible={""} header="Detail" style={{ width: "50vw" }}>
        <div>
          <ul className="list-unstyled">
            <li className="text-dark h5">
              Title: <span className="h6"></span>
            </li>
            <li className="text-dark h5">
              URL Pattern: <span className="h6"></span>
            </li>
            <li className="text-dark h5">
              Description: <span className="h6"></span>
            </li>
          </ul>
        </div>

        <div>
          <table className="table">
            <thead>
              <tr>
                <th scope="col">Name</th>
                <th scope="col">Content</th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </table>
        </div>
      </Dialog>

      <WebsiteListFilterDrawer
        filterDrawerVisible={filterDrawerVisible}
        setFilterDrawerVisible={setFilterDrawerVisible}
        mappingType={mappingType}
        selectedMappingStatus={selectedMappingStatus}
        setSelectedMappingStatus={setSelectedMappingStatus}
        websiteTypeItems={websiteTypeItems}
        selectWebsiteType={selectWebsiteType}
        setSelectWebsiteType={setSelectWebsiteType}
        searchText={searchText}
        setSearchText={setSearchText}
        searchWebsiteId={searchWebsiteId}
        setSearchWebsiteId={setSearchWebsiteId}
        loading={loading}
        handleResetFilter={handleResetFilter}
        handleSearch={hanldeWebisteSearch}
      />
    </div>
  );
};

export default WebsiteList;
